// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"f823f1ad","2458":"643c523d","2728":"ddf86119","4524":"c01ba795","5990":"16e73c2d"}[chunkId] + ".chunk.css";
};